import apiClient from '../apiClient';
import { POST_TOUR_OPERATOR_MARGIN_URL } from '../apiUrl';

const postTourOperatorSystemMarginApi = data => {
  return apiClient.post(POST_TOUR_OPERATOR_MARGIN_URL, data);
};

export default postTourOperatorSystemMarginApi;
